export const PUSH_PRODUCT_COMPARE = 'PUSH.PRODUCT.PRODUCT';
export const POP_PRODUCT_COMPARE = 'POP.PRODUCT.PRODUCT';
export const TOGGLE_SHOW_DIFFERENCES = 'TOGGLE.SHOW.DIFFERENCES';
export const SET_COMPARE_DATA = 'SET.COMPARE.DATA';
export const CLEAR_COMPARE = 'CLEAR.COMPARE';
export const OPEN_COMPARE = 'OPEN.COMPARE';
